import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  cargarProductoCostosPorId(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-barcode/search" + Session.getToken();
    return instance.post(url, params);
  },
  obtenerOpcionesProductoCostosPorCodigoBarras() {
    var url = ConfigAPI.baseURL + "costs/suppliers-products/by-barcode/options" + Session.getToken();
    return instance.get(url);
  },
  obtenerCondicionesIva() {
    var url = ConfigAPI.baseURL + "sales-iva-conditions" + Session.getToken();
    return instance.get(url);
  },
  updateProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/update" + Session.getToken();
    return instance.post(url, params);
  },
  agregarPrecioListaProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products" + Session.getToken();
    return instance.post(url, params);
  },
  editarPrecioListaProducto(data) {
    var params = data
    var url = ConfigAPI.baseURL + "price-list-products-item/" + data.id + Session.getToken();
    return instance.post(url, params);
  },
  eliminarPrecioListaProducto(id, data = {}) {
    var url = ConfigAPI.baseURL + "price-list-products/" + id + Session.getToken();
    return instance.delete(url, { data: data });
  },
  vincularProductoProveedor(data) {
    var params = data
    var url = ConfigAPI.baseURL + "costs/suppliers-products/convert" + Session.getToken();
    return instance.post(url, params);
  },
}

export default servicesAPI;
